import { getPipelineListGql } from '@/graphql/gql/build';
import { calVariables, request } from '@/graphql/util';

export async function getPipelineList(data, options = {}) {
  const result = await request(
    '/api/access/pb/cmd/DataServer/DataService/GraphqlQuery',
    {
      query: calVariables(getPipelineListGql, data),
    },
    options,
  );
  return result;
}
